import React from "react"
import HospitalExpenses from "./HospitalExpenses"
import DeathExpenses from "./DeathExpenses"
import LegalExpenses from "./LegalExpense"
import RoadSideExpense from "./RoadSideExpense"
import { ClaimTypeEnum } from "../../../lib/enum"

export default function ClaimExpenses(props) {

  if (props.type === ClaimTypeEnum.accidentalDeath) {
    return <DeathExpenses {...props} />
  }
  if (
    props.type === ClaimTypeEnum.legal ||
    props.type === ClaimTypeEnum.bdfAndPrisons
  ) {
    return <LegalExpenses {...props} />
  }
  if (props.type === ClaimTypeEnum.roadSideAssistance) {
    return <RoadSideExpense {...props} />
  }
  return (
    <HospitalExpenses {...props} />
  )
}